import axios from "axios";

// =============================================================
// API cho trang đăng ký công khai /gioi-thieu/<mã>.
// Người truy cập chưa có tài khoản nên dùng axios riêng, không đụng
// tới redux store / interceptor refresh token của app admin.
// =============================================================

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001/";

const affiliateAxios = axios.create({ baseURL });

const unwrap = (res) => {
  const body = res?.data;
  if (body && typeof body === "object" && "status" in body) {
    if (body.status === 200) return body.data;
    const error = new Error(extractMessage(body));
    error.response = res;
    throw error;
  }
  return body;
};

const extractMessage = (body, fallback = "Đã có lỗi xảy ra") => {
  if (!body) return fallback;
  if (Array.isArray(body.message)) return body.message[0] || fallback;
  if (body.message) return body.message;
  if (Array.isArray(body.errors) && body.errors[0]?.message) {
    return body.errors[0].message;
  }
  return fallback;
};

export const extractAffiliateError = (error, fallback = "Đã có lỗi xảy ra") =>
  extractMessage(error?.response?.data, error?.message || fallback);

// Thông tin người giới thiệu + danh mục cho form
export const getAffiliateInfoApi = async (code) =>
  unwrap(await affiliateAxios.get(`/affiliate/${code}`));

// Upload ảnh đại diện / CCCD, trả về { filePath }
export const uploadAffiliateImageApi = async (code, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return unwrap(
    await affiliateAxios.post(`/affiliate/${code}/upload/image`, formData)
  );
};

// Tạo tài khoản
export const affiliateRegisterApi = async (code, body) =>
  unwrap(await affiliateAxios.post(`/affiliate/${code}/register`, body));
